module.exports = __webpack_public_path__ + "img/splashLogo.ef323e04.png";